var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1704_10670)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 20,
    fill: "#FFD22F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9133 11.8375L32.1633 8.08746C32.0762 8.00029 31.9728 7.93114 31.859 7.88396C31.7452 7.83678 31.6232 7.8125 31.5 7.8125C31.3768 7.8125 31.2548 7.83678 31.141 7.88396C31.0272 7.93114 30.9238 8.00029 30.8367 8.08746L19.5867 19.3375C19.4997 19.4246 19.4307 19.528 19.3836 19.6418C19.3366 19.7556 19.3124 19.8776 19.3125 20.0007V23.7507C19.3125 23.9994 19.4113 24.2378 19.5871 24.4137C19.7629 24.5895 20.0014 24.6882 20.25 24.6882H24C24.1232 24.6883 24.2451 24.6642 24.3589 24.6171C24.4727 24.5701 24.5762 24.5011 24.6633 24.414L35.9133 13.164C36.0004 13.077 36.0696 12.9736 36.1168 12.8597C36.164 12.7459 36.1882 12.6239 36.1882 12.5007C36.1882 12.3775 36.164 12.2555 36.1168 12.1417C36.0696 12.0279 36.0004 11.9245 35.9133 11.8375ZM23.6121 22.8132H21.1875V20.3886L28.6875 12.8886L31.1121 15.3132L23.6121 22.8132ZM32.4375 13.9878L30.0129 11.5632L31.5 10.0761L33.9246 12.5007L32.4375 13.9878ZM35.25 19.0632V29.3757C35.25 29.873 35.0525 30.3499 34.7008 30.7016C34.3492 31.0532 33.8723 31.2507 33.375 31.2507H14.625C14.1277 31.2507 13.6508 31.0532 13.2992 30.7016C12.9475 30.3499 12.75 29.873 12.75 29.3757V10.6257C12.75 10.1285 12.9475 9.65154 13.2992 9.29991C13.6508 8.94828 14.1277 8.75074 14.625 8.75074H24.9375C25.1861 8.75074 25.4246 8.84951 25.6004 9.02532C25.7762 9.20114 25.875 9.4396 25.875 9.68824C25.875 9.93688 25.7762 10.1753 25.6004 10.3511C25.4246 10.527 25.1861 10.6257 24.9375 10.6257H14.625V29.3757H33.375V19.0632C33.375 18.8146 33.4738 18.5761 33.6496 18.4003C33.8254 18.2245 34.0639 18.1257 34.3125 18.1257C34.5611 18.1257 34.7996 18.2245 34.9754 18.4003C35.1512 18.5761 35.25 18.8146 35.25 19.0632Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1704_10670",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1704_10670"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1704_10670",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.e73fbd9dbabfc47bb40f5c41b6a90e94.svg";
export { ForwardRef as ReactComponent };